"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePACTBalance = exports.updatePACTBalance = void 0;
const tslib_1 = require("tslib");
const ImpactProvider_1 = require("./ImpactProvider");
const contracts_1 = require("./contracts");
const toNumber_1 = require("./toNumber");
const react_1 = tslib_1.__importStar(require("react"));
const updatePACTBalance = async (provider, networkId, address) => {
    const { pact } = (0, contracts_1.getContracts)(provider, networkId);
    if (!address || !(pact === null || pact === void 0 ? void 0 : pact.provider)) {
        return 0;
    }
    try {
        const pactBalance = await (pact === null || pact === void 0 ? void 0 : pact.balanceOf(address));
        return (0, toNumber_1.toNumber)(pactBalance);
    }
    catch (error) {
        console.log(`Error getting balance...\n${error}`);
        return 0;
    }
};
exports.updatePACTBalance = updatePACTBalance;
const usePACTBalance = () => {
    const { provider, address, networkId } = react_1.default.useContext(ImpactProvider_1.ImpactProviderContext);
    const { balance, setBalance } = react_1.default.useContext(ImpactProvider_1.PACTBalanceContext);
    (0, react_1.useEffect)(() => {
        if (address) {
            (0, exports.updatePACTBalance)(provider, networkId, address).then(b => setBalance(b));
        }
    }, [address]);
    return balance;
};
exports.usePACTBalance = usePACTBalance;
//# sourceMappingURL=usePACTBalance.js.map